import { render, staticRenderFns } from "./QrPhotoSelector.vue?vue&type=template&id=6c12747a"
import script from "./QrPhotoSelector.vue?vue&type=script&lang=js"
export * from "./QrPhotoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports